import { createFileRoute } from "@tanstack/react-router";

import { OrdersExportPage } from "@/features/orders";

export const Route = createFileRoute("/_authenticated/export-orders")({
  component: OrdersExportPage,
});
